import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Modal,
} from "react-bootstrap";
import PageTitle from "../components/common/PageTitle";
import { useTranslation } from "react-i18next";
import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import api from "../api/api";
import swal from "sweetalert";
import Pagination from "../views/Pagination";
import moment from "moment";
import { Line } from "react-chartjs-2";
import "./ConfigurationManagement.css";

import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const ConfigurationCrops = () => {
  const [cropsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [SearchName, setSearchName] = useState("");

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { t, i18n } = useTranslation();

  const [allCrops, setAllCrops] = useState([]);
  const [resultCalculKc, setResultCalculKc] = useState([]);
  const [displayDate, setDisplayDate] = useState("");

  const [cropData, setCropData] = useState({
    crop: "",
    crop_id: "",
    cropVariety: "",
    init: "",
    dev: "",
    mid: "",
    late: "",
    plantDate: "",
    rootMin: "",
    rootMax: "",
    kcInit: "",
    kcDev: "",
    kcMid: "",
    kcLate: "",
    allKcList: [],
    fractionRuPratique: "",
    cropAr: "",
    cropEn: "",
    cropPhoto: "",
    totalHours: "",
    minTemp: "",
    crop_nature: 0,
    temperature_chaleur: "",
    temperature_froid: "",
    nb_heure_froid: "",
    nb_heure_chaleur: "",
  });
  const [daysWarning, setDaysWarning] = React.useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [fieldRows, setFieldRows] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState({});
  const chartData = {
    labels: cropData?.allKcList?.map((item) => `Day ${item.day}`),
    datasets: [
      {
        label: "Kc",
        data: cropData?.allKcList?.map((item) => parseFloat(item.kc)),
        fill: false,
        pointRadius: 0,
        borderColor: "rgb(75, 192, 192)",
        tension: 0.3,
      },
    ],
  };
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: t("Kc_Evolution_by_Day"),
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Days",
        },
      },
      y: {
        title: {
          display: true,
          text: "Kc",
        },
        min: 0,
        max: 1.2,
      },
    },
  };

  const columns = [
    { field: "fieldId", headerName: t("Field ID"), width: 130 },
    { field: "name", headerName: t("Field Name"), flex: 1 },
    { field: "status", headerName: t("Status"), width: 160 },
  ];

  const [toggle, setToggle] = useState(false);
  const [toggleEdit, setToggleEdit] = useState(false);
  const [singleCrop, setSingleCrop] = useState({});

  const getCrops = async () => {
    try {
      await api
        .get("/crops/get-crops")
        .then((response) => {
          if (response.data.type === "success") {
            let listCrops = response.data.Crops;
            setAllCrops(listCrops);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getCrops();
  }, []);

  const getSingleCrop = (cropId, title) => {
    let data = {
      crop_id: cropId,
    };

    api
      .post("/crops/get-crop", data)
      .then((res) => {
        let dataCrops = res.data.crop;
        let date = dataCrops.plant_date;
        setSingleCrop(dataCrops);

        setCropData((prev) => ({
          ...prev,
          crop_id: dataCrops.crop_id,
          crop: dataCrops.crop,
          cropVariety: dataCrops.crop_variety,
          fractionRuPratique: dataCrops.practical_fraction,
          plantDate: date ? new Date(date + "T00:00:00") : null,
          init: dataCrops.init,
          dev: dataCrops.dev,
          mid: dataCrops.mid,
          late: dataCrops.late,
          rootMin: dataCrops.root_min,
          rootMax: dataCrops.root_max,
          minTemp: dataCrops.temperature,
          totalHours: dataCrops.hours,
          kcInit: dataCrops.kc_init,
          kcDev: dataCrops.kc_dev,
          kcMid: dataCrops.kc_mid,
          kcLate: dataCrops.kc_late,
          allKcList: dataCrops.all_kc,
          crop_nature: Number(dataCrops.crop_nature ?? 0),
          temperature_chaleur:dataCrops.temperature_chaleur,
          temperature_froid:dataCrops.temperature_froid,
          nb_heure_froid:dataCrops.nb_heure_froid,
          nb_heure_chaleur:dataCrops.nb_heure_chaleur,
        }));
      })
      .catch((error) => {
        console.error(error);
      });
    if (title === "Edit") {
      setToggleEdit(!toggleEdit);
    }
  };

  const onFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const onFileUploadEdit = async () => {
    if (!selectedFile) {
      swal(t("error"), t("please_select_file_first"), "error");
      return;
    }

    const formData = new FormData();
    formData.append("photo", selectedFile);
    formData.append("crop", singleCrop.crop);

    try {
      const token = localStorage.getItem("token"); // if your backend needs JWT
      const res = await api.post("/crop/upload-photo", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      setUploadedFile(res.data);
      swal(t("success"), t("photo_uploaded_successfully"), "success");
    } catch (err) {
      console.error(err);
      swal(t("error"), t("upload_failed"), "error");
    }
  };

  const addCrops = () => {
    // Parse the values as numbers to ensure proper addition
    const initDays = parseFloat(cropData.init) || 0;
    const devDays = parseFloat(cropData.dev) || 0;
    const midDays = parseFloat(cropData.mid) || 0;
    const lateDays = parseFloat(cropData.late) || 0;
    const totalDays = initDays + devDays + midDays + lateDays;

    // Check if total days exceed 365
    if (totalDays > 365) {
      swal(
        t("Error"),
        t("total_stage_days_error"),
        "error"
      );
      return; // Stop submission
    }
      let formattedDate = null;
  if (cropData.plantDate) {
    const d = new Date(cropData.plantDate);
    formattedDate = d.toISOString().slice(0, 19).replace("T", " ");
  }
    const datePattern = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])$/;
    if (!displayDate || !datePattern.test(displayDate)) {
      toast.error(t("invalid_date_format"));
      return;
    }
    const areKcAndPeriodsValid = [
      cropData.init,
      cropData.dev,
      cropData.mid,
      cropData.late,
      cropData.kcInit,
      cropData.kcMid,
      cropData.kcLate,
    ].every((val) => val !== "" && !isNaN(parseFloat(val)));
    let data = {
      crop: cropData.crop,
      crop_variety: cropData.cropVariety,
      plant_date: cropData.plantDate,
      init: cropData.init,
      dev: cropData.dev,
      mid: cropData.mid,
      late: cropData.late,
      kc_init: cropData.kcInit,
      kc_dev: cropData.kcDev,
      kc_mid: cropData.kcMid,
      kc_late: cropData.kcLate,
      root_max: cropData.rootMax,
      root_min: cropData.rootMin,
      hours: cropData.totalHours,
      temperature: cropData.minTemp,
      all_kc: areKcAndPeriodsValid ? resultCalculKc : [],
      practical_fraction: cropData.fractionRuPratique,
      crop_ar: cropData.cropAr,
      crop_en: cropData.cropEn,
      crop_nature: cropData.crop_nature,
      temperature_chaleur: cropData.temperature_chaleur,
      temperature_froid: cropData.temperature_froid,
      nb_heure_froid: cropData.nb_heure_froid,
      nb_heure_chaleur: cropData.nb_heure_chaleur,
    };
    api
      .post("/crops/add-crops", data)
      .then((response) => {
        if (response && response.data.type === "success") {
          swal(`${t("crop_added")}`, { icon: "success" });
          setToggle(false);
          getCrops();
          setCropData({
            crop: "",
            crop_id: "",
            cropVariety: "",
            plantDate: "",
            init: "",
            dev: "",
            mid: "",
            late: "",
            kcInit: "",
            kcDev: "",
            kcMid: "",
            kcLate: "",
            rootMax: "",
            rootMin: "",
            totalHours: "",
            minTemp: "",
            fractionRuPratique: "",
            allKcList: [],
            cropPhoto: "",
            cropAr: "",
            cropEn: "",
            crop_nature: 0,
          });
        }
        if (response && response.data.type === "danger") {
          swal(`${t("error")}`, { icon: "error" });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleEdit = (cropId) => {
    const initDays = parseFloat(cropData.init) || 0;
    const devDays = parseFloat(cropData.dev) || 0;
    const midDays = parseFloat(cropData.mid) || 0;
    const lateDays = parseFloat(cropData.late) || 0;
    const totalDays = initDays + devDays + midDays + lateDays;

    if (totalDays > 365) {
      swal(
        t("error"),
        t("total_stage_days_error"),
        "error"
      );
      return; // Stop submission
    }
    const datePattern = /^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])$/;
    if (!displayDate || !datePattern.test(displayDate)) {
      toast.error(t("invalid_date_format"));
      return;
    }
    let formattedDate = null;
  if (cropData.plantDate) {
    const d = new Date(cropData.plantDate);
    formattedDate = d.toISOString().slice(0, 19).replace("T", " ");
  }
    setIsSaving(true);
    const areKcAndPeriodsValid = [
      cropData.init,
      cropData.dev,
      cropData.mid,
      cropData.late,
      cropData.kcInit,
      cropData.kcMid,
      cropData.kcLate,
    ].every((val) => val !== "" && !isNaN(parseFloat(val)));

    let data = {
      crop_id: cropId,
      crop: cropData.crop,
      crop_variety: cropData.cropVariety,
      plant_date: formattedDate,
      init: cropData.init,
      dev: cropData.dev,
      mid: cropData.mid,
      late: cropData.late,
      kc_init: cropData.kcInit,
      kc_dev: cropData.kcDev,
      kc_mid: cropData.kcMid,
      kc_late: cropData.kcLate,
      root_max: cropData.rootMax,
      root_min: cropData.rootMin,
      hours: cropData.totalHours,
      temperature: cropData.minTemp,
      all_kc: areKcAndPeriodsValid ? resultCalculKc : [],
      practical_fraction: cropData.fractionRuPratique,
      crop_nature: cropData.crop_nature,
      temperature_chaleur: cropData.temperature_chaleur,
      temperature_froid: cropData.temperature_froid,
      nb_heure_froid: cropData.nb_heure_froid,
      nb_heure_chaleur: cropData.nb_heure_chaleur,
    };

    api
      .post("/crops/edit-crop", data)
      .then((response) => {
        if (response.data.type == "success") {
          const recalculation = response.data.recalculation_message;

          const successIds = recalculation.successfulFields || [];
          const failedIds = recalculation.failedFields || [];

          // Combine all IDs to fetch field names
          const allIds = [...new Set([...successIds, ...failedIds])];

          if (allIds.length === 0) {
            swal(
              t("Updated Crop"),
              t("No fields needed recalculation."),
              "success"
            );

            setToggleEdit(false);
            getCrops();

            // setCropData({
            //   crop: "",
            //   crop_id: "",
            //   cropVariety: "",
            //   plantDate: "",
            //   init: "",
            //   dev: "",
            //   mid: "",
            //   late: "",
            //   kcInit: "",
            //   kcDev: "",
            //   kcMid: "",
            //   kcLate: "",
            //   rootMax: "",
            //   rootMin: "",
            //   totalHours: "",
            //   minTemp: "",
            //   fractionRuPratique: "",
            //   allKcList: [],
            //   cropPhoto: "",
            //   cropAr: "",
            //   cropEn: "",
            // });

            setIsSaving(false);
            return;
          }

          // Fetch names from your new API
          api
            .post("/fields/by-ids", { fieldIds: allIds })
            .then((fieldsRes) => {
              const fieldMap = {};

              if (
                fieldsRes.data &&
                fieldsRes.data.type === "success" &&
                Array.isArray(fieldsRes.data.fields)
              ) {
                fieldsRes.data.fields.forEach((field) => {
                  fieldMap[field.id] = field.name || `Field ${field.id}`;
                });
              }
              // Extract only visible (i.e., returned) field IDs
              const visibleIds = Object.keys(fieldMap).map((id) =>
                parseInt(id)
              );

              // Filter visible success/failure
              const visibleSuccess = successIds.filter((id) =>
                visibleIds.includes(id)
              );
              const visibleFailed = failedIds.filter((id) =>
                visibleIds.includes(id)
              );

              const skippedIds = allIds.filter(
                (id) => !visibleIds.includes(id)
              );

              const rows = [
                ...visibleSuccess,
                ...visibleFailed,
                ...skippedIds,
              ].map((id, index) => ({
                id: index + 1,
                fieldId: id,
                name: fieldMap[id] || `ID: ${id}`,
                status: visibleSuccess.includes(id)
                  ? "✅ " + t("Success")
                  : visibleFailed.includes(id)
                  ? "❌ " + t("Error")
                  : "⚠️ " + t("Deleted"),
              }));

              setFieldRows(rows);
              setToggleEdit(false);
              setOpenDialog(true);
              getCrops();
              setIsSaving(false);
            })
            .catch((err) => {
              console.error("❌ Failed to fetch field names", err);
              swal(
                t("Crop updated"),
                t("Failed to fetch field names."),
                "warning"
              );

              setIsSaving(false);

              //   swal(" Crop has been updated", {
              //     icon: "success",
              //   });
              setToggleEdit(false);
              getCrops();
            });
        }
        if (response.data.type && response.data.type == "danger") {
          swal({
            icon: "error",
            title: t("Oops..."),
            text: t("Error editing crop"),
          });
          return false;
        }
      })
      .catch((error) => {
        console.error("Error editing crop:", error);
        swal({
          icon: "error",
          title: t("Oops..."),
          text: t("Error editing crop"),
        });
      });
  };

  const handleDelete = async (cropId) => {
    let data = {
      crop_id: cropId,
    };
    return await api
      .delete("/crops/delete-crop", { data: data })
      .then((response) => {
        if (response.data.type && response.data.type == "danger") {
          swal({
            title: t("Cannot Delete Crop"),
            icon: "warning",
          });
          return false;
        }
        if (response.data.type == "success") {
          getCrops();
          return true;
        }
        return false;
      })
      .catch((error) => {
        console.error("Error editing crop:", error);
        swal({
          title: t("Cannot Delete Crop"),
          icon: "error",
          text: t("Error deleting crop"),
        });
        setIsSaving(false);
        return false;
      });
  };

  const confirmDelete = (cropId) => {
    swal({
      title: t("Are you sure?"),
      text: t("Once deleted, you will not be able to recover this crop!"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then(async (Delete) => {
        if (Delete) {
          const deleted = await handleDelete(cropId);
          if (deleted) {
            swal(t("Crop deleted"), t("The crop has been deleted!"), "success");
          }
        }
      })
      .catch((error) => {
        swal({
          title: t("Cannot Delete Crop"),
          icon: "error",
          text: t("Error deleting crop"),
        });
      });
  };

  const filteredCrops = allCrops.filter((crops) => {
    if (SearchName !== "") {
      return crops?.crop?.toLowerCase()?.includes(SearchName.toLowerCase());
    }

    return crops;
  });

  const indexOfLastPost = currentPage * cropsPerPage;
  const indexOfFirstPost = indexOfLastPost - cropsPerPage;
  const currentCrops = filteredCrops.slice(indexOfFirstPost, indexOfLastPost);

  const onChangeHandler = async (e, idx) => {
    //modifier le setResultCalculKc pour ensuite ajouter le resultCalculKc dans l'action save pour inserer un objet clé (1,2,3..) valeur (kc dans le tableau html) dans la base de données colonne kc par jour
    // setResultCalculKc(state => ([...state ,{['day'] : day ,  ['kc'] : value }]), [])
    const value = e.target.value;
    const clone = [...cropData.allKcList];
    clone[idx] = { ...clone[idx], kc: value };

    setCropData((prev) => ({
      ...prev,
      allKcList: clone,
    }));

    setResultCalculKc(clone);
  };
  useEffect(() => {
    if (
      cropData.init &&
      cropData.dev &&
      cropData.mid &&
      cropData.late &&
      cropData.kcInit &&
      cropData.kcMid &&
      cropData.kcLate
    ) {
      const { results } = tableConfigKc();
      setResultCalculKc(results);
      setCropData((prev) => ({
        ...prev,
        allKcList: results,
      }));
    } else {
      setCropData((prev) => ({
        ...prev,
        allKcList: [],
      }));
    }
  }, [
    cropData.init,
    cropData.dev,
    cropData.mid,
    cropData.late,
    cropData.kcInit,
    cropData.kcMid,
    cropData.kcLate,
  ]);
  // Ajoutez ceci avec vos autres useEffect
useEffect(() => {
  if (cropData.plantDate) {
    const date = cropData.plantDate;

    // Si c'est un objet Date (ce que tu fais dans getSingleCrop)
    if (date instanceof Date && !isNaN(date)) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      setDisplayDate(`${day}/${month}`);
    } else if (typeof date === "string") {
      // Si c'est déjà une chaîne au format jj/mm ou yyyy-mm-dd
      if (date.includes("-")) {
        const [year, month, day] = date.split("-");
        setDisplayDate(`${day}/${month}`);
      } else if (date.includes("/")) {
        setDisplayDate(date);
      }
    }
  } else {
    setDisplayDate("");
  }
}, [cropData.plantDate]);

  const tableConfigKc = (async) => {
    let elements = [];
    let results = [];
    const init = parseInt(cropData.init);
    const dev = parseInt(cropData.dev);
    const mid = parseInt(cropData.mid);
    const late = parseInt(cropData.late);

    const kcInit = parseFloat(cropData.kcInit);
    const kcMid = parseFloat(cropData.kcMid);

    const kcLate = parseFloat(cropData.kcLate);

    let totalDays = init + dev + mid + late;

    for (let day = 1; day <= totalDays; day++) {
      let kc = 0;

      if (day <= init) {
        kc = kcInit;
      } else if (day <= init + dev) {
        const j = day - init;
        kc = kcInit + ((kcMid - kcInit) / dev) * j;
      } else if (day <= init + dev + mid) {
        kc = kcMid;
      } else if (day <= init + dev + mid + late) {
        const j = day - (init + dev + mid);
        kc = kcMid - ((kcMid - kcLate) / late) * j;
      } else {
        kc = kcLate;
      }

      kc = parseFloat(kc.toFixed(2));
      results.push({ day, kc });

      elements.push(
        <tr key={day}>
          <td>{day}</td>

          <td>
            <input
              name={`kc-${day}`}
              value={kc}
              onChange={(e) => onChangeHandler(e, day - 1)}
              className="my-1"
            />
          </td>
        </tr>
      );
    }

    return { elements, results };
  };
  const handleStageChange = (field, value) => {
    const updatedData = { ...cropData, [field]: value };
    const total =
      parseInt(updatedData.init || 0) +
      parseInt(updatedData.dev || 0) +
      parseInt(updatedData.mid || 0) +
      parseInt(updatedData.late || 0);

    if (total > 365) {
      setDaysWarning(
        "Total duration of all stages should not exceed 365 days."
      );
    } else {
      setDaysWarning("");
    }

    setCropData(updatedData);
  };
  return (
    <>
      <Container className="management-page admin-management-page configuration-management-page p-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={t("Crops_Configuration")}
            subtitle={t("Crops_Configuration")}
            className="text-sm-left"
          />
        </Row>
        <Row>
          <PageTitle sm="4" subtitle={t("search")} className="text-sm-left" />
        </Row>
        <Row form className="d-flex justify-content-center">
          <Col md="3" className="form-group">
            <Form.Group>
              <div className="d-flex">
                <Form.Control
                  value={SearchName}
                  onChange={(e) => setSearchName(e.target.value)}
                  id="search"
                  placeholder={t("search_by_name")}
                />
              </div>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <PageTitle
            sm="4"
            subtitle={t("my_actions")}
            className="text-sm-left"
          />
        </Row>
        <Row form className="py-2 d-flex justify-content-center">
          <ButtonGroup>
            <Button
              variant="outline-primary"
              onClick={() => {
                setToggle(true);
              }}
            >
              {t("Add_Crop")}
            </Button>
          </ButtonGroup>
        </Row>
        <Card>
          <Card.Header className="border-bottom">
            <div>
              <h5>{t("Crops_Info")}</h5>
            </div>
          </Card.Header>
          <Card.Body>
            <table className="table mb-0 text-center">
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0">
                    {t("Crop")}
                  </th>
                  <th scope="col" className="border-0">
                    {t("Start_season_Date")}
                  </th>
                  <th scope="col" className="border-0"></th>
                </tr>
              </thead>
              <tbody>
                {currentCrops.map((crop) => {
                  let plantDate = moment(crop.plant_date).format("DD/MM");
                  return (
                    <tr>
                      <td>{crop.crop}</td>
                      <td>{plantDate}</td>

                      <td>
                        <ButtonGroup size="sm" className="mr-2 configuration-action-group">
                          <Button
                            title={t('edit')}
                            onClick={() => {
                              getSingleCrop(crop.id, "Edit");
                            }}
                            className="configuration-action-button"
                          >
                            <i className="fas fa-pen" aria-hidden="true" />
                          </Button>
                          <Button
                            title={t('delete')}
                            onClick={() => {
                              confirmDelete(crop.id);
                            }}
                            className="configuration-action-button"
                            variant="danger"
                          >
                            <i className="fas fa-trash" aria-hidden="true" />
                          </Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Card.Body>
        </Card>
        <Row className="py-4 justify-content-center">
          <Pagination
            usersPerPage={cropsPerPage}
            totalUsers={filteredCrops.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        </Row>
      </Container>
      <Modal
        size="lg"
        centered={true}
        show={toggle}
        onHide={() => setToggle(false)}
        className="custom-modal-height"
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "10px",
            }}
          >
            <Button
              // theme="success"
              onClick={() => {
                addCrops();
              }}
              className="mb-2 mr-1 btn btn-success"
            >
              <i className="fa fa-check mx-2"></i>
              {isSaving ? (
                <>
                  <CircularProgress
                    size={20}
                    color="inherit"
                    style={{ marginRight: 8 }}
                  />
                  {t("Saving...")}
                </>
              ) : (
                t("save")
              )}
            </Button>
            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-danger"
              disabled={isSaving}
              onClick={() => {
                setToggle(false);
                setDaysWarning("");
              }}
            >
              <i className="fa fa-times mx-2"></i>
              {t("cancel")}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row className="gap-2">
            <Col lg="7" md="12" sm="12" className="border-right">
              <Card.Body>
                <Row className="gap-2">
                  <Col lg="10" md="12" sm="12">
                    <Form.Group>
                      <Form.Label>{t("Upload_Crop_Photo")}</Form.Label>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        {/* File input wrapper */}
                        <div style={{ position: "relative", flex: 1 }}>
                          <Form.Control
                            type="file"
                            onChange={onFileChange}
                            style={{
                              position: "absolute",
                              opacity: 0,
                              cursor: "pointer",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                          <Form.Control
                            type="text"
                            placeholder={t("Choose_Photo")}
                            value={selectedFile ? selectedFile.name : ""}
                            readOnly
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        {/* Upload button aligned */}
                        <Button variant="success" onClick={onFileUploadEdit}>
                          {t("Upload_Photo")}
                        </Button>
                      </div>

                      {/* Preview */}
                      {selectedFile && (
                        <div className="mt-2">
                          <img
                            src={URL.createObjectURL(selectedFile)}
                            alt="Preview"
                            style={{ maxWidth: "150px", maxHeight: "150px" }}
                          />
                        </div>
                      )}
                    </Form.Group>

                    
                  </Col>
                  <Col lg="5" md="12" sm="12">
                  <Form.Group>
                      <label htmlFor="crop">{t("Crop_Type")}</label>
                      <Form.Control
                        id="crop"
                        placeholder={t("Crop_Type")}
                        value={cropData.crop}
                        onChange={(e) =>
                          setCropData({ ...cropData, crop: e.target.value })
                        }
                      />
                    </Form.Group>
                    </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="cropAr"> {t("Crop_Type")} (Ar)</label>
                      <Form.Control
                        id="cropAr"
                        placeholder={t("Crop_Type")}
                        value={cropData.cropAr}
                        onChange={(e) =>
                          setCropData({ ...cropData, cropAr: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="cropEn"> {t("Crop_Type")}(En)</label>
                      <Form.Control
                        id="cropEn"
                        placeholder={t("Crop_Type")}
                        value={cropData.cropEn}
                        onChange={(e) =>
                          setCropData({ ...cropData, cropEn: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <p style={{ margin: "0px" }}>{t("culture_type")}</p>

                      <Form.Select
                        value={cropData.crop_nature ?? ""}
                        onChange={(e) =>
                          setCropData((prev) => ({
                            ...prev,
                            crop_nature: Number(e.target.value), // converti en nombre 0 ou 1
                          }))
                        }
                      >
                        <option value="" disabled hidden>
                          {t("Choisir le type de culture")}
                        </option>
                        <option value={1}>{t("Culture_annuelle")}</option>
                        <option value={0}>{t("Culture_maraîchère")}</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="practicalFractionRu">
                        {t("Practical_Fraction_Ru")}
                      </label>
                      <Form.Control
                        id="practicalFractionRu"
                        placeholder={t("Practical_Fraction_Ru")}
                        value={cropData.fractionRuPratique}
                        onChange={(e) => {
                          setCropData({
                            ...cropData,
                            fractionRuPratique: e.target.value,
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="minTemp">{t("Temp.")}</label>
                      <Form.Control
                        id="minTemp"
                        placeholder={t("Temp.")}
                        value={cropData.minTemp}
                        onChange={(e) => {
                          setCropData({ ...cropData, minTemp: e.target.value });
                        }}
                        type="number"
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="totalHours"> {t("Number_of_hours")}</label>
                      <Form.Control
                        id="totalHours"
                        placeholder={t("Number_of_hours")}
                        value={cropData.totalHours}
                        onChange={(e) => {
                          setCropData({
                            ...cropData,
                            totalHours: e.target.value,
                          });
                        }}
                        type="number"
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="temperature_chaleur">
                        {t("Température_de_chaleur")}
                      </label>
                      <Form.Control
                        id="temperature_chaleur"
                        type="number"
                        placeholder={t("Température_de_chaleur")}
                        value={cropData.temperature_chaleur || ""}
                        onChange={(e) =>
                          setCropData({
                            ...cropData,
                            temperature_chaleur: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="temperature_froid">
                        {t("Température_de_froid")}
                      </label>
                      <Form.Control
                        id="temperature_froid"
                        type="number"
                        placeholder={t("Température_de_froid")}
                        value={cropData.temperature_froid || ""}
                        onChange={(e) =>
                          setCropData({
                            ...cropData,
                            temperature_froid: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="nb_heure_froid">
                        {t("Nombre_d’heure_de_froid")}
                      </label>
                      <Form.Control
                        id="nb_heure_froid"
                        type="number"
                        placeholder={t("Nombre_d’heure_de_froid")}
                        value={cropData.nb_heure_froid || ""}
                        onChange={(e) =>
                          setCropData({
                            ...cropData,
                            nb_heure_froid: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  
                </Row>
              </Card.Body>
            </Col>
            <Col lg="4" md="12" sm="12">
            
            
                    
                    <Form.Group>
                      <label htmlFor="nb_heure_chaleur">
                        {t("Nombre_d’heure_de_chaleur")}
                      </label>
                      <Form.Control
                        id="nb_heure_chaleur"
                        type="number"
                        placeholder={t("Nombre_d’heure_de_chaleur")}
                        value={cropData.nb_heure_chaleur || ""}
                        onChange={(e) =>
                          setCropData({
                            ...cropData,
                            nb_heure_chaleur: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                    <Form.Group>
                      <label htmlFor="plantDate">
                        {t("Start_season_Date")}
                      </label>
                      <Form.Control
                        id="plantDate"
                        placeholder={t("dd/MM")}
                        type="text"
                        value={displayDate}
                        onChange={(e) => {
                          let input = e.target.value.replace(/\D/g, "");

                          // Validation du jour (max 31)
                          if (input.length >= 2) {
                            let day = parseInt(input.substring(0, 2));
                            if (day > 31) day = 31;
                            if (day < 1 && input.length === 2) day = 1;
                            input =
                              day.toString().padStart(2, "0") +
                              input.substring(2);
                          }

                          // Validation du mois (max 12)
                          if (input.length >= 4) {
                            let month = parseInt(input.substring(2, 4));
                            if (month > 12) month = 12;
                            if (month < 1) month = 1;
                            input =
                              input.substring(0, 2) +
                              month.toString().padStart(2, "0");
                          }

                          // Formatage avec /
                          let formatted = input;
                          if (input.length >= 2) {
                            formatted =
                              input.substring(0, 2) +
                              "/" +
                              input.substring(2, 4);
                          }

                          formatted = formatted.substring(0, 5);
                          setDisplayDate(formatted);

                          // Si on a JJ/MM complet, on reconstruit la date complète
                          if (input.length === 4) {
                            const day = input.substring(0, 2);
                            const month = input.substring(2, 4);
                            const year = new Date().getFullYear();

                            setCropData({
                              ...cropData,
                              plantDate: `${year}-${month}-${day}`,
                            });
                          } else {
                            // Si la date n'est pas complète, on vide plant_date
                            setCropData({
                              ...cropData,
                              plantDate: "",
                            });
                          }
                        }}
                        maxLength={5}
                      />
                    </Form.Group>
               
              <h6 className="mt-2">Kc</h6>
              <div className="d-flex justify-content-center align-items-center">
                <Form.Control
                  placeholder="kc_init"
                  className="m-1"
                  value={cropData.kcInit}
                  onChange={(e) =>
                    setCropData({ ...cropData, kcInit: e.target.value })
                  }
                />

                <Form.Control
                  placeholder="kc_mid"
                  className="m-1"
                  value={cropData.kcMid}
                  onChange={(e) =>
                    setCropData({ ...cropData, kcMid: e.target.value })
                  }
                />
                <Form.Control
                  placeholder="kc_late"
                  value={cropData.kcLate}
                  onChange={(e) =>
                    setCropData({ ...cropData, kcLate: e.target.value })
                  }
                />
              </div>
              <h6>{t("Stage(Days)")}</h6>
              <div className="d-flex justify-content-around align-items-center">
                <Form.Control
                  placeholder="Init"
                  className="m-1"
                  value={cropData.init}
                  onChange={(e) => handleStageChange("init", e.target.value)}
                />
                <Form.Control
                  placeholder="Dev"
                  value={cropData.dev}
                  // onChange={(e) => {
                  //   checkTotalDays();
                  //   setCropData({ ...cropData, dev: e.target.value });
                  // }}
                  onChange={(e) => handleStageChange("dev", e.target.value)}
                />
                <Form.Control
                  placeholder="Mid"
                  className="m-1"
                  value={cropData.mid}
                  // onChange={(e) => {
                  //   checkTotalDays();
                  //   setCropData({ ...cropData, mid: e.target.value });
                  // }}
                  onChange={(e) => handleStageChange("mid", e.target.value)}
                />
                <Form.Control
                  placeholder="Late"
                  value={cropData.late}
                  // onChange={(e) => {
                  //   checkTotalDays();
                  //   setCropData({ ...cropData, late: e.target.value });
                  // }}
                  onChange={(e) => handleStageChange("late", e.target.value)}
                />
              </div>
              {daysWarning && (
                <small
                  style={{
                    color: "red",
                    marginTop: "5px",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  {daysWarning}
                </small>
              )}
              <h6>{t("roots")}</h6>
              <div className="d-flex justify-content-around align-items-center">
                <Form.Control
                  placeholder="Min"
                  className="m-1"
                  value={cropData.rootMin}
                  onChange={(e) =>
                    setCropData({ ...cropData, rootMin: e.target.value })
                  }
                />
                <Form.Control
                  placeholder="Max"
                  value={cropData.rootMax}
                  onChange={(e) =>
                    setCropData({ ...cropData, rootMax: e.target.value })
                  }
                />
              </div>
            </Col>
          </Row>
          <Row>
            {cropData.allKcList && cropData.allKcList.length > 0 && (
              <Col lg="12" md="12" sm="12" className="mt-1">
                <Line data={chartData} options={chartOptions} />
              </Col>
            )}
          </Row>
          <Row className="border-top mt-2">
            {cropData.allKcList && cropData.allKcList.length > 0 && (
              <Col lg="12" md="12" sm="12" className="mt-1">
                {/* <button onClick={() => tableConfigKc()}>Calculer</button> */}
                <table className="table mb-0 border text-center">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0">
                        {t("Day")}
                      </th>

                      <th scope="col" className="border-0">
                        {t("Kc")}
                      </th>
                    </tr>
                  </thead>
                  {cropData.allKcList &&
                    cropData.allKcList.map((result, indx) => (
                      <tr key={result.day}>
                        <td>{result.day}</td>

                        <td>
                          <input
                            name={`kc-${result.day}`}
                            className="my-1"
                            value={result.kc}
                            onChange={(e) => onChangeHandler(e, indx)}
                          />
                        </td>
                      </tr>
                    ))}
                </table>
              </Col>
            )}
            <ToastContainer
              position="top-center" // <-- centre horizontal
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Row>
        </Modal.Body>
      </Modal>
      <Modal
        size="lg"
        centered={true}
        show={toggleEdit}
        onHide={() => setToggleEdit(false)}
        className="custom-modal-height"
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              gap: "10px",
            }}
          >
            <Button
              // theme="success"
              onClick={() => {
                handleEdit(singleCrop.id);
              }}
              className="mb-2 mr-1 btn btn-success"
            >
              <i className="fa fa-check mx-2"></i>
              {t("save")}
            </Button>
            <Button
              // theme="success"
              className="mb-2 mr-1 btn btn-danger"
              onClick={() => {
                setToggleEdit(false);
                setDaysWarning("");
              }}
            >
              <i className="fa fa-times mx-2"></i>
              {t("cancel")}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Row className="">
            <Col lg="12" md="12" sm="12">
              <Card.Body>
                <Row className="gap-3">
                  <Col lg="4" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="crop">{t("Crop_Type")}</label>
                      <Form.Control
                        id="crop"
                        placeholder={t("Crop_Type")}
                        value={cropData.crop}
                        onChange={(e) =>
                          setCropData({ ...cropData, crop: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="4" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="cropAr">{t("Crop_Type")} (Ar)</label>
                      <Form.Control
                        id="cropAr"
                        placeholder={t("Crop_Type")}
                        value={cropData.cropAr}
                        onChange={(e) =>
                          setCropData({ ...cropData, cropAr: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="3" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="cropEn">{t("Crop_Type")}(En)</label>
                      <Form.Control
                        id="cropEn"
                        placeholder={t("Crop_Type")}
                        value={cropData.cropEn}
                        onChange={(e) =>
                          setCropData({ ...cropData, cropEn: e.target.value })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="4" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="cultureType">{t("culture_type")}</label>
                      <Form.Select
                        id="cultureType"
                        value={cropData.crop_nature ?? ""}
                        onChange={(e) =>
                          setCropData((prev) => ({
                            ...prev,
                            crop_nature: Number(e.target.value), // converti en nombre
                          }))
                        }
                      >
                        <option value={1}>{t("Culture_annuelle")}</option>
                        <option value={0}>{t("Culture_maraîchère")}</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col lg="7" md="12" sm="12">
                    <Form.Group>
                      <Form.Label>{t("Upload_Crop_Photo")}</Form.Label>

                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        {/* File input wrapper */}
                        <div style={{ position: "relative", flex: 1 }}>
                          <Form.Control
                            type="file"
                            onChange={onFileChange}
                            style={{
                              position: "absolute",
                              opacity: 0,
                              cursor: "pointer",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                          <Form.Control
                            type="text"
                            placeholder={t("Choose_Photo")}
                            value={selectedFile ? selectedFile.name : ""}
                            readOnly
                            style={{ cursor: "pointer" }}
                          />
                        </div>

                        {/* Upload button aligned */}
                        <Button variant="success" onClick={onFileUploadEdit}>
                          {t("Upload_Photo")}
                        </Button>
                      </div>

                      {/* Preview */}
                      {selectedFile && (
                        <div className="mt-2">
                          <img
                            src={URL.createObjectURL(selectedFile)}
                            alt="Preview"
                            style={{ maxWidth: "150px", maxHeight: "150px" }}
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col lg="3" md="12" sm="12">
                    <Form.Group>
                      <label htmlFor="plantDate">
                        {t("Start_season_Date")}
                      </label>
                      <Form.Control
                        id="plantDate"
                        placeholder={t("dd/MM")}
                        type="text"
                        value={displayDate}
                        onChange={(e) => {
                          let input = e.target.value.replace(/\D/g, "");

                          // Validation du jour (max 31)
                          if (input.length >= 2) {
                            let day = parseInt(input.substring(0, 2));
                            if (day > 31) day = 31;
                            if (day < 1 && input.length === 2) day = 1;
                            input =
                              day.toString().padStart(2, "0") +
                              input.substring(2);
                          }

                          // Validation du mois (max 12)
                          if (input.length >= 4) {
                            let month = parseInt(input.substring(2, 4));
                            if (month > 12) month = 12;
                            if (month < 1) month = 1;
                            input =
                              input.substring(0, 2) +
                              month.toString().padStart(2, "0");
                          }

                          // Formatage avec /
                          let formatted = input;
                          if (input.length >= 2) {
                            formatted =
                              input.substring(0, 2) +
                              "/" +
                              input.substring(2, 4);
                          }

                          formatted = formatted.substring(0, 5);
                          setDisplayDate(formatted);

                          // Si on a JJ/MM complet, on reconstruit la date complète
                          if (input.length === 4) {
                            const day = input.substring(0, 2);
                            const month = input.substring(2, 4);
                            const year = new Date().getFullYear();

                            setCropData({
                              ...cropData,
                              plantDate: `${year}-${month}-${day}`,
                            });
                          } else {
                            // Si la date n'est pas complète, on vide plant_date
                            setCropData({
                              ...cropData,
                              plantDate: "",
                            });
                          }
                        }}
                        maxLength={5}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="4" md="12" sm="12">
                    <Form.Group className="d-flex justify-content-center  flex-column">
                      <label htmlFor="practicalFractionRu">
                        {t("Practical_Fraction_Ru")}
                      </label>
                      <Form.Control
                        id="practicalFractionRu"
                        placeholder={t("Practical_Fraction_Ru")}
                        value={cropData.fractionRuPratique}
                        onChange={(e) => {
                          setCropData({
                            ...cropData,
                            fractionRuPratique: e.target.value,
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="4" md="12" sm="12">
                    <Form.Group className="d-flex justify-content-center flex-column">
                      <label htmlFor="minTemp">{t("Temp.")}</label>
                      <Form.Control
                        id="minTemp"
                        placeholder={t("Temp.")}
                        value={cropData.minTemp}
                        onChange={(e) => {
                          setCropData({ ...cropData, minTemp: e.target.value });
                        }}
                        type="number"
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="3" md="12" sm="12">
                    <Form.Group className="d-flex justify-content-center  flex-column">
                      <label htmlFor="totalHours"> {t("Number_of_hours")}</label>
                      <Form.Control
                        id="totalHours"
                        placeholder={t("Number_of_hours")}
                        value={cropData.totalHours}
                        onChange={(e) => {
                          setCropData({
                            ...cropData,
                            totalHours: e.target.value,
                          });
                        }}
                        type="number"
                      />
                    </Form.Group>
                  </Col>
                   <Col lg="4" md="12" sm="12">
              <Form.Group>
                <label htmlFor="temperature_chaleur">
                  {t("Température_de_chaleur")}
                </label>
                <Form.Control
                  id="temperature_chaleur"
                  type="number"
                  placeholder={t("Température_de_chaleur")}
                  value={cropData.temperature_chaleur || ""}
                  onChange={(e) =>
                    setCropData({
                      ...cropData,
                      temperature_chaleur: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col lg="4" md="12" sm="12">
              <Form.Group>
                <label htmlFor="temperature_froid">
                  {t("Température_de_froid")}
                </label>
                <Form.Control
                  id="temperature_froid"
                  type="number"
                  placeholder={t("Température_de_froid")}
                  value={cropData.temperature_froid || ""}
                  onChange={(e) =>
                    setCropData({
                      ...cropData,
                      temperature_froid: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col lg="4" md="12" sm="12">
              <Form.Group>
                <label htmlFor="nb_heure_froid">
                  {t("Nombre_d’heure_de_froid")}
                </label>
                <Form.Control
                  id="nb_heure_froid"
                  type="number"
                  placeholder={t("Nombre_d’heure_de_froid")}
                  value={cropData.nb_heure_froid || ""}
                  onChange={(e) =>
                    setCropData({
                      ...cropData,
                      nb_heure_froid: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
            <Col lg="4" md="12" sm="12">
              <Form.Group>
                <label htmlFor="nb_heure_chaleur">
                  {t("Nombre_d’heure_de_chaleur")}
                </label>
                <Form.Control
                  id="nb_heure_chaleur"
                  type="number"
                  placeholder={t("Nombre_d’heure_de_chaleur")}
                  value={cropData.nb_heure_chaleur || ""}
                  onChange={(e) =>
                    setCropData({
                      ...cropData,
                      nb_heure_chaleur: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
                </Row>
              </Card.Body>
            </Col>
           

            <Col lg="12" md="12" sm="12" className="mt-4">
              <h6>{t("roots")}</h6>
              <div className="d-flex justify-content-around align-items-center">
                <Form.Control
                  placeholder="Min"
                  className="m-1"
                  value={cropData.rootMin}
                  onChange={(e) =>
                    setCropData({ ...cropData, rootMin: e.target.value })
                  }
                />
                <Form.Control
                  placeholder="Max"
                  value={cropData.rootMax}
                  onChange={(e) =>
                    setCropData({ ...cropData, rootMax: e.target.value })
                  }
                />
              </div>
              <h6 className="mt-2">Kc *</h6>
              <div className="d-flex justify-content-center align-items-center">
                <Form.Control
                  placeholder="kc_init"
                  className="m-1"
                  value={cropData.kcInit}
                  required
                  onChange={(e) =>
                    setCropData({ ...cropData, kcInit: e.target.value })
                  }
                />

                <Form.Control
                  placeholder="kc_mid"
                  required
                  className="m-1"
                  value={cropData.kcMid}
                  onChange={(e) =>
                    setCropData({ ...cropData, kcMid: e.target.value })
                  }
                />
                <Form.Control
                  placeholder="kc_late"
                  required
                  value={cropData.kcLate}
                  className="px-2"
                  onChange={(e) =>
                    setCropData({ ...cropData, kcLate: e.target.value })
                  }
                />
              </div>

              <h6 className="mt-2">{t("Stage(Days)")}*</h6>
              <div className="d-flex justify-content-around align-items-center">
                <Form.Control
                  placeholder="Init"
                  required
                  className="m-1"
                  value={cropData.init}
                  // onChange={(e) => {
                  //   checkTotalDays();
                  //   setCropData({ ...cropData, init: e.target.value });
                  // }}
                  onChange={(e) => handleStageChange("init", e.target.value)}
                />
                <Form.Control
                  placeholder="Dev"
                  required
                  value={cropData.dev}
                  // onChange={(e) => {
                  //   checkTotalDays();
                  //   setCropData({ ...cropData, dev: e.target.value });
                  // }}
                  onChange={(e) => handleStageChange("dev", e.target.value)}
                />
                <Form.Control
                  placeholder="Mid"
                  required
                  className="m-1"
                  value={cropData.mid}
                  // onChange={(e) => {
                  //   checkTotalDays();
                  //   setCropData({ ...cropData, mid: e.target.value });
                  // }}
                  onChange={(e) => handleStageChange("mid", e.target.value)}
                />
                <Form.Control
                  placeholder="Late"
                  required
                  value={cropData.late}
                  // onChange={(e) => {
                  //   checkTotalDays();
                  //   setCropData({ ...cropData, late: e.target.value });
                  // }}
                  onChange={(e) => handleStageChange("late", e.target.value)}
                />
              </div>
              {daysWarning && (
                <small
                  style={{
                    color: "red",
                    marginTop: "5px",
                    display: "block",
                    textAlign: "center",
                  }}
                >
                  {daysWarning}
                </small>
              )}
            </Col>
          </Row>
          <Row>
            {/* <Col lg="12" md="12" sm="12" className="mt-1">
              <Line data={chartData} options={chartOptions} />
            </Col> */}
            <Col lg="12" md="12" sm="12" className=" p-2">
              <div
                style={{ position: "relative", minHeight: "400px" }}
                className="mb-5"
              >
                <div
                  style={{
                    filter:
                      cropData.allKcList && cropData.allKcList.length > 0
                        ? "none"
                        : "blur(1px)",
                    transition: "filter 0.3s ease",
                    boxShadow: "0 2px 2px var(--sf-night-shadow, rgba(0, 0, 0, 0.1))",
                    borderRadius: "8px",
                    backgroundColor: "var(--sf-night-surface, #fff)",
                    padding: "1rem",
                  }}
                >
                  <Line data={chartData} options={chartOptions} />
                </div>

                {(!cropData.allKcList || cropData.allKcList.length === 0) && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "var(--sf-night-surface, rgba(255, 255, 255, 0.7))",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      pointerEvents: "none",
                      padding: "2rem",
                      textAlign: "center",
                      color: "var(--sf-night-danger, #b83d53)",
                      fontWeight: "700",
                      fontSize: "1rem",

                      borderRadius: "8px",
                    }}
                  >
                    {t("please_provide_kc_values_chart", { defaultValue: "Please provide Kc values and stage durations to display the chart." })}
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row className="border-top mt-2">
            <Col lg="12" md="12" sm="12" className="mt-1">
              {/* <button onClick={() => tableConfigKc()}>Calculer</button> */}
              <div
                style={{ position: "relative", minHeight: "300px" }}
                className="mb-4"
              >
                <div
                  style={{
                    filter:
                      cropData.allKcList && cropData.allKcList.length > 0
                        ? "none"
                        : "blur(1px)",
                    transition: "filter 0.3s ease",
                    boxShadow: "0 2px 2px var(--sf-night-shadow, rgba(0, 0, 0, 0.1))",
                    borderRadius: "8px",
                    backgroundColor: "var(--sf-night-surface, #fff)",
                    padding: "1rem",
                    overflowX: "auto",
                  }}
                ></div>
                <table className="table mb-0 border text-center">
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0">
                        {t("Day")}
                      </th>

                      <th scope="col" className="border-0">
                        {t("Kc")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {cropData.allKcList &&
                      cropData.allKcList.map((result, indx) => {
                        return (
                          <tr>
                            <td>{result.day}</td>
                            <td>
                              <input
                                name={indx}
                                key={indx}
                                className="my-1"
                                value={result.kc}
                                onChange={(e) => onChangeHandler(e, indx)}
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                {(!cropData.allKcList || cropData.allKcList.length === 0) && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "var(--sf-night-surface, rgba(255, 255, 255, 0.7))",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      pointerEvents: "none",
                      padding: "2rem",
                      textAlign: "center",
                      color: "var(--sf-night-danger, #b83d53)",
                      fontWeight: "700",
                      fontSize: "1rem",
                      borderRadius: "8px",
                    }}
                  >
                    {t("please_enter_kc_stages_first", { defaultValue: "To edit daily Kc values, please enter the Kc stages and growth periods first." })}
                  </div>
                )}
              </div>
            </Col>
            
          </Row>
        </Modal.Body>
      </Modal>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{t("Field Recalculation Report")}</DialogTitle>
        <DialogContent>
          <div style={{ height: 500, width: "100%" }}>
            <DataGrid
              rows={fieldRows}
              columns={columns}
              initialState={{
                pagination: { paginationModel: { page: 0, pageSize: 5 } },
              }}
              pageSizeOptions={[5, 10]}
            />
          </div>
        </DialogContent>
      </Dialog>
      <ToastContainer
              position="top-center" // <-- centre horizontal
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
    </>
  );
};

export default ConfigurationCrops;
